import React, { useEffect, useState } from 'react'
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import { InputAdornment, Select, SelectChangeEvent } from '@mui/material';
import { connect, useSelector } from 'react-redux';
import { getStores } from '../../Redux/actions/store';
import { toast } from 'react-toastify';
import { orderTypeList, submitComplaint } from '../../Redux/actions/customer';
import { useHistory } from 'react-router-dom';
import Header from '../../Components/Header';
import GoBack from '../BackButton/GoBack';
import { useTranslation } from 'react-i18next';
import { checkPhone, MOBILE_STARS, NUMBERS_LIMIT, PHONE_CODE } from '../../lib';
import Footer from '../../Components/Footer';

function FeedBack(props: any) {
  const history = useHistory();
  const storeList = useSelector((state: any) => state.store.storeList);
  const orderTypes = useSelector((state: any) => state.customer.orderTypes);
  const userInfo = useSelector((state: any) => state.customer.userInfo);
  const storeSelected = useSelector((state: any) => state.store.storeSelected);

  const [body, setBody] = useState({
    name: "",
    phone_number: '',
    email_address: "",
    store_id: "",
    order_date: '',
    message: "",
    receipt_number: "",
    type: "",
    order_channel: "",
    order_type: "",
  });

  const [disable, setDisable] = useState(true);
  const [phoneError, setPhoneError] = useState(false)
  const [emailError, setEmailError] = useState(false)

  const handleChange = (e: any) => {
    if (e.target.name != "order_date")
      setBody({ ...body, [e.target.name]: e.target.value })
    const hasEmptyValue = Object.values({ ...body, [e.target.name]: e.target.value }).some(value => value == '');
    if (hasEmptyValue) {
      setDisable(true)
    }
    else {
      setDisable(false)
    }
    if (e.target.name == "email_address") {
      const emailRegex = /^\S+@\S+\.\S+$/;
      setEmailError(!emailRegex.test(e.target.value));
    }

  }
  const handlePhone = (e: any) => {
    const { value } = e.target;
    if (value.length <= NUMBERS_LIMIT) {
      setBody({ ...body, [e.target.name]: value })
    }
    if (!checkPhone(value)) return;
    if (value.length == NUMBERS_LIMIT) {
      setPhoneError(false);
    }
    if (value.length < NUMBERS_LIMIT) {
      setPhoneError(true);
    }
  };

  const handleEnterPress = (e: any) => {
    if (e.key === 'Enter') {
      const hasEmptyValue = Object.values(body).some(value => value === '');
      if (hasEmptyValue || phoneError || emailError) {
        toast.error(t("FILL_ALL_FIELDS"))
      } else {
        handleSubmit();
      }
    }
  }

  const handleSubmitButton = (value: boolean) => {
    setDisable(value);
  }

  const handleSubmit = () => {
    setDisable(true);
    props.submitComplaint(body, history, "", handleSubmitButton);
  }

  useEffect(() => {
    props.getStores()
    props.orderTypeList()
  }, [])

  useEffect(()=> {

    if(userInfo) {

      let selectedStore = null;
      let full_name = ""

      if(storeSelected && storeList && storeList.length > 0) {
        selectedStore = storeList.find((store: any) => store.store_id === storeSelected.store_id)
      }

      if(userInfo?.first_name) {
        full_name = userInfo?.first_name + " "
      }
      if(userInfo?.last_name) {
        full_name = full_name + userInfo?.last_name
      }

      setBody({
        ...body,
        name: full_name,
        phone_number: userInfo?.phone_number?.split("-")[1],
        email_address: userInfo?.email_address ?? "",
        store_id : selectedStore?.store_id ?? "",
      })
    }

  }, [userInfo, storeSelected])

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleDate = (e: any) => {
    const selectedDate = e.target.value;
    const currentDate = new Date().toISOString().split('T')[0];

    if (selectedDate <= currentDate) {
      setBody({ ...body, [e.target.name]: e.target.value })
      const hasEmptyValue = Object.values({ ...body, [e.target.name]: e.target.value }).some(value => value == '');
      if (hasEmptyValue) {
        setDisable(true)
      }
      else {
        setDisable(false);
      }
    } else {
      setDisable(true)
      toast.error(t("FUTURE_DATE_ERROR"))
      setBody({ ...body, [e.target.name]: "" })

    }

  }
  const { t } = useTranslation();

  return (
    <>
      <Header />
      <section className="container mt-120">
        <div className="contact-us-container position-relative">
          <div className="back-btn-position web-backbtn">
            <GoBack />
          </div>
          <h2 className="about-title mb-0 mt-5">
          {t("HAVESOMEFEEDBACKTOSHARE")}
          </h2>
          <h5 className="about-place">
            {t("WELLYOUVECOMETOTHERIGHTPLACE")}
          </h5>
          <p className="final-product">
            {t("FILLINTHESECTIONSBELOWANDWE'LLBEINTOUCHSOON")}
          </p>
          <div className="row">
            <div className="col-md-6">
              <div className="contactus-box">
                <h3 className="contact-title">{t("CONTACTDETAILS")}</h3>
                <div className="row">
                  <div className="col-md-6 mt-2">
                    <TextField
                      onChange={handleChange}
                      value={body.name}
                      onKeyPress={handleEnterPress}
                      name="name"
                      className="field-style contact-number-ar"
                      id="filled-basic"
                      label={`${t("FULLNAME")} *`}
                      variant="filled"
                      color="error"
                    />
                  </div>
                  <div className="col-md-6 mt-2">
                    <TextField
                      value={body.phone_number}
                      onChange={handlePhone}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment
                            className="font-normal number-field"
                            position="start"
                          >
                            {PHONE_CODE}
                          </InputAdornment>
                        ),
                      }}
                      type="text"
                      onKeyPress={handleEnterPress}
                      helperText={
                        phoneError ? `${t("PHONE_ERROR",{limit:NUMBERS_LIMIT})}` : ""
                      }
                      name="phone_number"
                      className="field-style contact-number-ar"
                      id="filled-basic"
                      label={`${t("PHONE_NUMBER")} (${MOBILE_STARS}) *`}
                      variant="filled"
                      color="error"
                    />
                  </div>
                  <div className="col-md-12 mt-3">
                    <TextField
                      onChange={handleChange}
                      value={body.email_address}
                      onKeyPress={handleEnterPress}
                      helperText={emailError ? <>{t("INVALID_EMAIL")}</> : ""}
                      name="email_address"
                      className="field-style contact-number-ar"
                      id="filled-basic"
                      label={`${t("EMAIL")} *`}
                      variant="filled"
                      color="error"
                    />
                  </div>
                  <div className="col-md-12 mt-3">
                    <TextField
                      onChange={handleChange}
                      onKeyPress={handleEnterPress}
                      type="number"
                      name="receipt_number"
                      className="field-style contact-number-ar"
                      id="filled-basic"
                      label={`${t("ORDERID")} *`}
                      variant="filled"
                      color="error"
                    />
                  </div>
                  <div className="col-md-12 mt-3">
                    <FormControl
                      className="field-style contact-number-ar"
                      variant="filled"
                      color="error"
                    >
                      <InputLabel id="demo-simple-select-filled-label">
                         {t("FEEDBACKCHANNEL")} *
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-filled-label"
                        id="demo-simple-select-filled"
                        name="order_channel"
                        onChange={handleChange}
                        className="field-style"
                      >
                        <MenuItem value={"Dine in"}>{t("DINEIN")}</MenuItem>
                        <MenuItem value={"Take away"}>{t("TAKEAWAY")}</MenuItem>
                        <MenuItem value={"Pickup"}>{t("PICKUP")} </MenuItem>
                        <MenuItem value={"Drive Thru"}>{t("DRIVETHRU")}</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="contactus-box">
                <h3 className="contact-title">{t("ABOUT_YOUR_VISIT")}</h3>
                <div className="row">
                  <div className="col-md-6 mt-2">
                    <FormControl
                      className="field-style contact-number-ar"
                      variant="filled"
                      color="error"
                    >
                      <InputLabel id="demo-simple-select-filled-label">
                        {t("SELECT_STORE")}
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-filled-label"
                        id="demo-simple-select-filled"
                        name="store_id"
                        onChange={handleChange}
                        value={body.store_id}
                      >
                        {storeList.map((store: any) => (
                          <MenuItem value={store.store_id}>
                            {store?.store_name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div className="col-md-6 mt-2">
                    <TextField
                      type="date"
                      value={body.order_date}
                      onChange={(e: any) => {
                        handleChange(e);
                        handleDate(e);
                      }}
                      name="order_date"
                      onKeyPress={handleEnterPress}
                      className="field-style contact-number-ar"
                      id="filled-basic"
                      label={`${t("DATE")} *`}
                      variant="filled"
                      color="error"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />

                  </div>
                  <div className="col-6 mt-2">
                    <FormControl
                      className="field-style contact-number-ar"
                      variant="filled"
                      color="error"
                    >
                      <InputLabel id="demo-simple-select-filled-label">
                      {t("FEEDBACK_CATEGORY")} *
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-filled-label"
                        id="demo-simple-select-filled"
                        name="order_type"
                        onChange={handleChange}
                        className="field-style"
                      >
                        {
                          orderTypes.length > 0 ?
                            orderTypes.map((type: any) => (
                              <MenuItem value={type.type_id}>{type.order_type}</MenuItem>
                            ))
                          : 
                            <MenuItem value={""}>{t("NO_TYPE_FOUND")}</MenuItem>
                        }
                      </Select>
                    </FormControl>
                  </div>
                  <div className="col-6 mt-2">
                    <FormControl
                      className="field-style contact-number-ar"
                      variant="filled"
                      color="error"
                    >
                      <InputLabel id="demo-simple-select-filled-label">
                      {t("FEEDBACK_TYPE")} *
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-filled-label"
                        id="demo-simple-select-filled"
                        name="type"
                        onChange={handleChange}
                        className="field-style"
                      >
                        <MenuItem value={"Comments"}>
                        {t("COMMENTS")}
                        </MenuItem>
                        <MenuItem value={"Suggestions"}>{t("SUGGESTIONS")}</MenuItem>
                        <MenuItem value={"Questions"}>{t("QUESTIONS")}</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div className="col-md-12 mt-3">
                    <textarea
                      onChange={handleChange}
                      onKeyPress={handleEnterPress}
                      name="message"
                      className="form-control feetback-comment feedback-share"
                      placeholder={t("FEEDBACK_MESSAGE")}
                      id="filled-basic"
                      rows={2}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Button
            onClick={handleSubmit}
            disabled={disable || phoneError || emailError ? true : false}
            className={` ${disable || phoneError || emailError ? "disable-btn" : "able-btn"
              } w-25 p-3 m-auto d-flex mt-4`}
            variant="contained"
            color="error"
          >
            {t("SUBMIT")}
          </Button>
        </div>
      </section>
      <Footer />
    </>
  );
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    getStores: function (data: any) {
      dispatch(getStores());
    },
    submitComplaint: function (data: any, history?: any, _?: any, submitDisable? : any) {
      dispatch(submitComplaint(data, history, _, submitDisable));
    },
    orderTypeList: function (data: any) {
      dispatch(orderTypeList());
    }
  }
}
export default connect(null, mapDispatchToProps)(FeedBack);
